import { ArticleContent } from '@/mocks/articles';

interface ArticleContentRendererProps {
  sections: ArticleContent['sections'];
}

export default function ArticleContentRenderer({ sections }: ArticleContentRendererProps) {
  return (
    <div className="flex flex-col gap-6">
      {sections.map((section, idx) => {
        switch (section.type) {
          case 'heading':
            return (
              <h2 key={idx} className="text-xl md:text-2xl font-heading font-bold text-foreground-100 mt-4">
                {section.content}
              </h2>
            );

          case 'paragraph':
            return (
              <p key={idx} className="text-sm md:text-base text-foreground-300 leading-relaxed">
                {section.content}
              </p>
            );

          case 'quote':
            return (
              <blockquote key={idx} className="border-l-4 border-primary-500/60 pl-5 py-3 my-2 bg-primary-500/5 rounded-r-lg">
                <p className="text-sm md:text-base text-foreground-200 italic leading-relaxed">
                  &ldquo;{section.content}&rdquo;
                </p>
              </blockquote>
            );

          case 'image':
            return (
              <figure key={idx} className="my-2">
                <div className="rounded-lg overflow-hidden">
                  <img
                    src={section.image}
                    alt={section.imageAlt || '51黑料网配图'}
                    className="w-full h-auto object-cover"
                    title={section.imageAlt || '51黑料网'}
                  />
                </div>
                {section.imageAlt && (
                  <figcaption className="mt-2 text-xs text-foreground-500 text-center">
                    {section.imageAlt}
                  </figcaption>
                )}
              </figure>
            );

          case 'list':
            return (
              <ul key={idx} className="flex flex-col gap-3 pl-2">
                {section.items?.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm md:text-base text-foreground-300">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400 text-xs font-semibold mt-0.5 flex-shrink-0">
                      {i + 1}
                    </span>
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            );

          default:
            return null;
        }
      })}
    </div>
  );
}